<template lang="html">
  <div class="con" v-show="false">
    <div class="sailWind">
      <div class="tryOutBtn" @click="getTryOut">免费试用</div>
    </div>
    
    <div class="sailWindElse">
      链接已更新，请到派兹公众号查看最新内容~
    </div>
  </div>
</template>

<script>
  // import { pagebase } from '@/utils/http.js';

  export default {
    data() {
      return {

      }
    },

    created() {
      window.location.href = 'https://www.elecnest.com/h5/activity?uid=517981&activity=3';
      
    },

    mounted() {
      document.getElementById('favicon').setAttribute('href', process.env.BASE_URL + 'pzeda.ico')
    },

    methods: {
      getTryOut() {
        this.$router.push({
          path: '/sailWindForm',
        })
      },
    },
  }
</script>

<style lang="css" scoped>
  .con {
    width: 100%;
    height: 100%;
  }

  .sailWind {
    box-sizing: border-box;
    padding: 0 2rem;
    padding-top: 70rem;
    width: 100%;
    height: 81.2rem;
    background-image: url('~@/assets/image/sailWind/back1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .tryOutBtn {
    width: 100%;
    height: 4.8rem;
    background-color: #28D6EB;
    border-radius: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    color: #020D24;
    font-weight: 600;
  }

  .sailWindElse {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>